module.exports = __webpack_public_path__ + "static/media/2.c37074d6.png";